module.exports = __webpack_public_path__ + "static/media/DocumentLight.259268d5.svg";